import cssFile from "./App.css";
import scssFile from "./App.scss";

const exportedFile =
  process.env.NODE_ENV !== "development" ? cssFile : scssFile;
export default exportedFile;



// WEBPACK FOOTER //
// ./src/styles.js